import { BackgroundLogoSvg } from '../../../presentation/assets/icons/svgComponents'

import * as S from './styles'

const LoginLayout = ({ children }: any) => (
  <S.Container>
    <BackgroundLogoSvg className="background-svg" />
    {children}
  </S.Container>
)

export default LoginLayout
